<template>
	<v-container fluid class="pb-0">
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat class="pb-0 pt-0">
					<v-card-text class="pa-2">
						<v-row class="d-flex justify-space-between">
							<v-col class="pb-0 pt-0">
								<v-card-title class="justify-left align-center pa-2">
									{{ $t('titles.guaranteedSpent') }}</v-card-title
								>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0">
								<v-simple-table fixed-header dense height="400px">
									<template v-slot:default>
										<thead>
											<tr>
												<th class="text-left" style="white-space: nowrap">
													{{ $t('fields.type') }}
												</th>
												<th class="text-left" style="white-space: nowrap">
													{{ $t('fields.course') }}
												</th>
												<th style="text-align: right; white-space: nowrap">
													{{ $t('fields.priceNeto') }}
												</th>
												<th style="text-align: right; white-space: nowrap">
													{{ $t('fields.loyaltyPoints') }}
												</th>
												<th class="text-left" style="white-space: nowrap">
													{{ $t('fields.candidate') }}
												</th>
												<th class="text-left" style="white-space: nowrap">
													{{ $t('fields.date') }}
												</th>
												<th class="text-left" style="white-space: nowrap">
													{{ $t('fields.user') }}
												</th>
											</tr>
										</thead>
										<tbody>
											<tr
												v-for="(item, key) in items"
												:key="key"
												:class="{ 'cursor-pointer': true }"
											>
												<td style="white-space: nowrap">
													{{ item.payment_contract_item_type.name }}
												</td>
												<td style="white-space: nowrap">
													{{
														item.planned_course_id != null
															? item.planned_course.course.code +
															  ' ' +
															  item.planned_course.course.name +
															  ' - ' +
															  item.planned_course.office.name +
															  ' ' +
															  item.planned_course.start_date
																	.split('-')
																	.reverse()
																	.join('.')
															: ''
													}}
												</td>
												<td style="text-align: right; white-space: nowrap">
													{{
														item.price != null
															? Number.isInteger(item.price)
																? item.price.toLocaleString('hr') + ',00'
																: /^\d+\.\d{1}$/.test(item.price.toString())
																? item.price.toLocaleString('hr') + '0'
																: item.price.toLocaleString('hr')
															: ''
													}}
												</td>
												<td style="text-align: right; white-space: nowrap">
													{{ item.loyalty_points }}
												</td>
												<td style="white-space: nowrap">
													{{ item.candidate.full_name }}
												</td>
												<td style="white-space: nowrap">
													{{ item.date }}
												</td>
												<td style="white-space: nowrap">
													{{ item.user != null ? item.user.full_name : '' }}
												</td>
											</tr>
										</tbody>
									</template>
								</v-simple-table>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'PaymentContractUsedItems',
	data: function () {
		return {
			items: [],
		};
	},
	emits: ['deletionPossible'],
	methods: {
		reloadData() {
			let vm = this;
			this.$APICall(
				'get',
				'payment-contract-used-items/' + this.$route.params.id,
				null,
				(data, success) => {
					if (success) {
						vm.items = data.items;
						if (data.total <= 0) {
							vm.$emit('deletionPossible', true);
						}
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		if (this.$route.params.id != 0) {
			this.reloadData();
		}
	},
};
</script>

<style scoped></style>
